"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const styles_1 = require("./styles");
const RotaDropdownHeaderNew = ({ isOpen, setIsOpen, labelText, hasValue = false, optionText, onClose, isError = false, isDisabled = false, children, placeholderText = "" }) => {
    var _a;
    const theme = (0, styled_components_1.useTheme)();
    const headerRef = (0, react_1.useRef)(null);
    const wrapperRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClickOutside = (e) => {
        var _a;
        const isClickInside = (_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target);
        !isClickInside && setIsOpen(false);
    };
    return (react_1.default.createElement(styles_1.DropdownWrapper, { isError: isError, isOpen: isOpen, isDisabled: isDisabled, ref: wrapperRef },
        react_1.default.createElement(styles_1.DropdownHeader, { isError: isError, isDisabled: isDisabled, ref: headerRef, onClick: () => setIsOpen(!isOpen), isOpen: isOpen },
            react_1.default.createElement(styles_1.Label, { isError: isError, isDisabled: isDisabled, hasValue: hasValue, isOpen: isOpen }, labelText),
            react_1.default.createElement(styles_1.HeaderPlaceholder, { hasValue: hasValue, isOpen: isOpen }, placeholderText),
            react_1.default.createElement(styles_1.SelectedOptionText, { hasValue: hasValue }, optionText),
            react_1.default.createElement(styles_1.StyledArrowDown, { isOpen: isOpen, color: theme.neutral.dark })),
        isOpen && (react_1.default.createElement(styles_1.DropdownBody, { headerHeigh: ((_a = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0 }, children))));
};
exports.default = RotaDropdownHeaderNew;
